// eslint-disable-next-line import/prefer-default-export
export const LOAD_RESELLERS = 'LOAD_RESELLERS';
export const SET_RESELLERS_FILTER = 'SET_RESELLERS_FILTER';
export const SET_RESELLER_PAGINATION = 'SET_RESELLER_PAGINATION';
export const SET_RESELLER_SORT = 'SET_RESELLER_SORT';
export const ADD_NEW_RESELLER = 'ADD_NEW_RESELLER';
export const EDIT_RESELLER = 'EDIT_RESELLER';
export const SET_EMPTY_EDITABLE_RESELLER = 'SET_EMPTY_EDITABLE_RESELLER';
export const LOAD_EDITABLE_RESELLER = 'LOAD_EDITABLE_RESELLER';
export const RESET_FILTER_RESELLERS = 'RESET_FILTER_RESELLERS';
export const LOAD_RESELLER_SEGMENTS = 'LOAD_RESELLER_SEGMENTS';
export const LOAD_SEGMENTS_FOR_RESELLERS = 'LOAD_SEGMENTS_FOR_RESELLERS';
export const SET_EMPTY_SEGMENTS_FOR_RESELLERS = 'SET_EMPTY_SEGMENTS_FOR_RESELLERS';
export const LOAD_PRODUCT_GROUPS_FOR_RESELLERS = 'LOAD_PRODUCT_GROUPS_FOR_RESELLERS';
export const SET_PRODUCT_GROUPS_PAGINATION_FOR_RESELLERS = 'SET_PRODUCT_GROUPS_PAGINATION_FOR_RESELLERS';
export const SET_PRODUCT_GROUPS_FILTER_FOR_RESELLERS = 'SET_PRODUCT_GROUPS_FILTER_FOR_RESELLERS';
export const RESET_PRODUCTS_GROUPS_FILTERS_FOR_RESELLERS = 'RESET_PRODUCTS_GROUPS_FILTERS_FOR_RESELLERS';
export const SET_ACTIVE_SEGMENT = 'SET_ACTIVE_SEGMENT';
export const ADD_SEGMENT_PRODUCT_GROUP = 'ADD_SEGMENT_PRODUCT_GROUP';
export const LOAD_EDITABLE_SEGMENT_FOR_RESELLERS = 'LOAD_EDITABLE_SEGMENT_FOR_RESELLERS';
export const SET_EMPTY_EDITABLE_SEGMENT_FOR_RESELLERS = 'SET_EMPTY_EDITABLE_SEGMENT_FOR_RESELLERS';
export const LOAD_EDITABLE_SEGMENT_PRODUCT_GROUP_FOR_RESELLERS = 'LOAD_EDITABLE_SEGMENT_PRODUCT_GROUP_FOR_RESELLERS';
export const SET_EMPTY_ACTIVE_SEGMENT = 'SET_EMPTY_ACTIVE_SEGMENT';
export const DELETE_SEGMENT_PRODUCT_GROUP = 'DELETE_SEGMENT_PRODUCT_GROUP';
export const CHANGE_RESELLER_SEGMENT_ORDER = 'CHANGE_RESELLER_SEGMENT_ORDER';
export const DELETE_INVOICE_TEMPLATE = 'DELETE_INVOICE_TEMPLATE';
